import axiosInstance from "../config/axiosConfig";

export const login = async ({ login, password }) => {
  return await axiosInstance.post("account/login", { login, password });
};

export const encryptText = async (string) => {
  return axiosInstance.get(`account/${string}`);
};
